import { getIn } from 'seamless-immutable';
import { dispatchEvent, createPage, createProject, createNavigation, createContext } from '../helpers';

export const recommendationLoad = ({ routerProps, client, body }) => {
  try {
    dispatchEvent('recommendation:load', createRecLoadBody({ routerProps, client, body }));
  } catch (e) {}
};

const createRecLoadBody = ({ routerProps, client, body }) => ({
  page: createPage({ routerProps, client, body }),
  project: createProject({ routerProps, client, body }),
  navigation: createNavigation(),
  shelves: createShelves({ routerProps, client, body }),
  context: createContext({ client }),
});

const createShelves = ({ routerProps, client, body }) => {
  const { template = {} } = body?.page;

  const shelves = Object.keys(template)
    .reduce((prev, curr) => prev.concat(template[curr] || []), [])
    .filter(position => position.type === 'recommendation')
    .map(pos => ({
      ...getIn(body, ['page', 'components', pos.id]),
      type: pos.id,
    }))
    .filter(Boolean)
    .filter(shelf => shelf.products);

  const mvt = getIn(body, ['mvt'], []);
  return { shelves, source: 'rich', success: shelves.length > 0, total: shelves.length, mvt };
};
